import TextButton from "library/Atoms/Button/TextButton";
import DefaultModal from "library/Molecules/Modal/DefaultModal";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const DownloadOrderReportModal = ({ onClose, children }) => {
  const { t } = useTranslation();

  return (
    <DefaultModal id="download-report-modal" title={t("dashboard.modals.downloadReportModal.title")} onClose={onClose}>
      {children}

      <div className="d-flex col-12 mt-2 px-0 justify-content-center">
        <TextButton
          id="close-download-report-modal-btn"
          className="mx-auto"
          label={t("common.buttons.closeBtn")}
          onClick={onClose}
        />
      </div>
    </DefaultModal>
  );
};

DownloadOrderReportModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default DownloadOrderReportModal;
